let $onScreen = document.querySelectorAll('.on-screen');

const modalOpenEvent = new CustomEvent('modalopen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalCloseEvent = new CustomEvent('modalclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalAfterOpenEvent = new CustomEvent('modalafteropen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalAfterCloseEvent = new CustomEvent('modalafterclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const setModalWidths = () => {
    const $activeModals = document.querySelectorAll('.modal.modal--active, .modal-resize.modal--active');
    const $fixedEls = document.querySelectorAll('.fixed-el');

    let hasActiveModal = false;

    if ($activeModals.length) {
        $activeModals.forEach($modal => {
            if (!$modal.dataset?.modalMaxWidth || window.innerWidth < $modal.dataset.modalMaxWidth) {
                hasActiveModal = true;
            }
        });
    }

    if (!hasActiveModal) {
        enableBodyScroll();
        
        if ($fixedEls.length) {
            $fixedEls.forEach($fixedEl => {
                $fixedEl.style.width = '';
            });
        }

        if ($activeModals.length) {
            $activeModals.forEach($modal => {
                if ($modal.dataset?.modalMaxWidth && window.innerWidth >= $modal.dataset.modalMaxWidth) {
                    closeModal($modal);
                }
            });
        }

        return;
    } else {
        enableBodyScroll();

        if ($fixedEls.length) {
            $fixedEls.forEach($fixedEl => {
                $fixedEl.style.width = document.body.clientWidth + 'px';
            });
        }

        if ($activeModals.length) {
            $activeModals.forEach($modal => {
                if (!$modal.dataset?.modalMaxWidth || window.innerWidth < $modal.dataset.modalMaxWidth) {
                    $modal.style.width = document.body.clientWidth + 'px';
                }
            });
        }

        disableBodyScroll();
    }
};

const enableBodyScroll = () => {
    document.querySelector('html').classList.remove('no-scroll');
    document.querySelector('html').style.width = '';
};

const disableBodyScroll = () => {
    document.querySelector('html').style.width = document.body.clientWidth + 'px';
    document.querySelector('html').classList.add('no-scroll');
};

const setTransitionDelays = () => {
    $onScreen.forEach($el => {
        const $onScreenTransitionEls = $el.querySelectorAll('[data-on-screen-transition-delay]');

        $onScreenTransitionEls.forEach($onScreenTransitionEl => {
            const onScreenTransitionDelay = $onScreenTransitionEl?.dataset?.onScreenTransitionDelay ? 
                JSON.parse($onScreenTransitionEl.dataset.onScreenTransitionDelay) : null;

            if (!onScreenTransitionDelay) return;

            if (typeof onScreenTransitionDelay === 'number') {
                $onScreenTransitionEl.style.transitionDelay = `${onScreenTransitionDelay}s`;
            }

            if (typeof onScreenTransitionDelay === 'object') {
                for (const key in onScreenTransitionDelay) {
                    if (window.innerWidth < parseInt(key)) continue;

                    $onScreenTransitionEl.style.transitionDelay = `${onScreenTransitionDelay[key]}s`;
                }
            }
        });
    });
}
    
const checkOnScreenEls = () => {
    const $onScreen = document.querySelectorAll('.on-screen');

    $onScreen.forEach($el => {
        const $onScreenTransitionEls = $el.querySelectorAll('[data-on-screen-transition-delay]');

        if ($el.getBoundingClientRect().top <= (window.innerHeight * 0.95) || 
            (window.scrollY + window.innerHeight) >= document.body.scrollHeight) {

            setTransitionDelays();

            $el.classList.add('is-on-screen');
        } else {
            $onScreenTransitionEls.forEach($onScreenTransitionEl => {
                $onScreenTransitionEl.style.transitionDelay = '';
            });

            $el.classList.remove('is-on-screen');
        }
    });
}

const closeModal = $modal => {
    if (!$modal) return;

    $modal.dispatchEvent(modalCloseEvent);

    const { modalBtns, modalElements } = $modal.dataset;

    const $modalToggleBtns = $modal.dataset?.modalToggleBtn ? document.querySelectorAll($modal.dataset.modalToggleBtn) : false;

    enableBodyScroll();
    
    $modal.classList.remove('modal--active');

    if (modalBtns) {
        const $modalBtns = document.querySelectorAll(modalBtns);

        $modalBtns?.forEach($modalBtn => {
            $modalBtn.setAttribute('aria-expanded', 'false');
        });
    }

    if (modalElements) {
        const $modalElements = document.querySelectorAll(modalElements);

        $modalElements?.forEach($modalElement => {
            $modalElement.classList.remove('modal-expanded');
        });
    }

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            $modalToggleBtn.classList.remove('modal--active');
            $modalToggleBtn.ariaExpanded = false;
        });
    }

    setModalWidths();

    $modal.dispatchEvent(modalAfterCloseEvent);
}

const openModal = $modal => {
    if (!$modal) return;

    $modal.dispatchEvent(modalOpenEvent);

    const { modalBtns, modalElements } = $modal.dataset;

    console.log(modalElements);

    const $modalToggleBtns = $modal.dataset?.modalToggleBtn ? document.querySelectorAll($modal.dataset.modalToggleBtn) : false;

    disableBodyScroll();

    $modal.classList.add('modal--active');

    if (modalBtns) {
        const $modalBtns = document.querySelectorAll(modalBtns);

        $modalBtns?.forEach($modalBtn => {
            $modalBtn.setAttribute('aria-expanded', 'true');
        });
    }

    if (modalElements) {
        const $modalElements = document.querySelectorAll(modalElements);

        $modalElements?.forEach($modalElement => {
            $modalElement.classList.add('modal-expanded');
        });
    }

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            $modalToggleBtn.classList.add('modal--active');
            $modalToggleBtn.ariaExpanded = true;
        });
    }

    const $modalFocusEl = $modal.querySelector('a[href], button, input:not([type="hidden"]), textarea, select, details,[tabindex]:not([tabindex="-1"])');

    if ($modalFocusEl) {
        $modalFocusEl.focus();
    }

    const escapeListener = e => {
        if (e.key !== 'Escape') return;

        closeModal($modal);

        document.removeEventListener('keyup', escapeListener);
    };

    document.addEventListener('keyup', escapeListener);

    setModalWidths();

    $modal.dispatchEvent(modalAfterOpenEvent);
};

const initModals = () => {
    const $modalToggleBtns = document.querySelectorAll('.modal-open, .modal-close');
    const $modalResize = document.querySelectorAll('.modal, .modal-resize');

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            const $modal = $modalToggleBtn.dataset?.modalTarget ? document.getElementById($modalToggleBtn.dataset.modalTarget) : false;

            if (!$modal) return;

            $modalToggleBtn.addEventListener('click', e => {
                e.preventDefault();
                
                if ($modal.classList.contains('modal--active') && $modalToggleBtn.classList.contains('modal-close')) {
                    closeModal($modal);
                } else if (!$modal.classList.contains('modal--active') && $modalToggleBtn.classList.contains('modal-open')) {
                    openModal($modal);
                }
            });
        });
    }

    if ($modalResize.length) {
        $modalResize.forEach($modal => {
            if ($modal.id && window.location.hash && '#' + $modal.id === window.location.hash) {
                openModal($modal);
            }
        });

        window.addEventListener('resize', setModalWidths);
    }

    setModalWidths();
}

const getSiblings = e => {
    // for collecting siblings
    let siblings = []; 
    // if no parent, return no sibling
    if(!e.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling  = e.parentNode.firstChild;
    
    // collecting siblings
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
};

(() => {
    const initSiteNavDropdowns = () => {
        const $siteMenuModalSubMenuWraps = document.querySelectorAll('.site-menu-modal .menu-item-has-children');
        const $siteMenuBarSubMenuWraps = document.querySelectorAll('.site-menu-bar .menu-item-has-children');

        if ($siteMenuModalSubMenuWraps.length) {
            $siteMenuModalSubMenuWraps.forEach($subMenuWrap => {
                const $subMenuWrapBtn = $subMenuWrap.querySelector('a');
                const $subMenu = $subMenuWrap.querySelector('.sub-menu-dropdown');

                const showSubMenu = () => {
                    $subMenu.style.height = `${$subMenu.scrollHeight}px`;
                    $subMenuWrap.classList.add('menu-item--active');

                    setTimeout(() => {
                        $subMenu.style.height = '';
                    }, 250);
                };

                const hideSubMenu = () => {
                    $subMenu.style.height = `${$subMenu.scrollHeight}px`;
                    $subMenuWrap.classList.remove('menu-item--active');

                    setTimeout(() => {
                        $subMenu.style.height = '';
                    }, 10);
                };

                $subMenuWrapBtn.addEventListener('click', e => {
                    e.preventDefault();

                    $subMenuWrapBtn.removeEventListener('mouseleave', () => {
                        hideSubMenu();
                    });

                    if ($subMenuWrap.classList.contains('menu-item--active')) {
                        hideSubMenu();
                    } else {
                        showSubMenu();
                    }
                });
            });
        }

        if ($siteMenuBarSubMenuWraps.length) {
            $siteMenuBarSubMenuWraps.forEach($subMenuWrap => {
                const $subMenuWrapBtn = $subMenuWrap.querySelector('a');

                $subMenuWrap.addEventListener('mouseenter', () => {
                    $subMenuWrap.classList.add('menu-item--active');
                });

                $subMenuWrap.addEventListener('mouseleave', () => {
                    $subMenuWrap.classList.remove('menu-item--active');
                });

                $subMenuWrapBtn.addEventListener('click', e => {
                    e.preventDefault();
                });
            });
        }
    };

    initSiteNavDropdowns();
})();

(() => {
    const initAnchorLinks = () => {
        let $anchorLinks = document.querySelectorAll('a');

        $anchorLinks = $anchorLinks ? Array.from($anchorLinks).filter($anchorLink => {
            const url = new URL($anchorLink.href);

            return url?.hash && document.querySelector(url?.hash);
        }) : $anchorLinks;

        if (!$anchorLinks) return;

        $anchorLinks.forEach($anchorLink => {
            $anchorLink.addEventListener('click', e => {
                const url = new URL($anchorLink.href);

                const $targetEl = url ? document.querySelector(url?.hash) : null;

                if (!$targetEl) return;

                e.preventDefault();

                window.scrollTo({
                    top: $targetEl?.getBoundingClientRect()?.y + window.scrollY,
                    behavior: 'smooth',
                });
            });
        });
    };

    window.addEventListener('scroll', () => {
        checkOnScreenEls();
    });

    window.addEventListener('load', () => {
        checkOnScreenEls();
    });

    window.addEventListener('resize', () => {
        setTransitionDelays();
    });
    
    initModals();
    setTransitionDelays();
    checkOnScreenEls();
    initAnchorLinks();
})();
